import { setFieldError } from "../../../redux/slices/vendorFormSlice";

// Reusable field validation
const validateFields = (formData, validations, dispatch) => {
  let isValid = true;

  for (const field in validations) {
    const rawValue = formData[field];
    const value = typeof rawValue === "string" ? rawValue.trim() : rawValue;
    const rules = validations[field];

    if (
      rules.required &&
      (value === "" ||
        value === undefined ||
        value === null ||
        (Array.isArray(value) && value.length === 0))
    ) {
      dispatch(setFieldError({ name: field, message: rules.message }));
      isValid = false;
      continue;
    }

    if (
      rules.pattern &&
      typeof value === "string" &&
      value &&
      !rules.pattern.test(value)
    ) {
      dispatch(setFieldError({ name: field, message: rules.patternMessage }));
      isValid = false;
      continue;
    }

    dispatch(setFieldError({ name: field, message: "" }));
  }

  return isValid;
};

// Personal Detail Validations
const personalDetailValidations = {
  ownerName: {
    required: true,
    message: "Please enter the owner's full name.",
  },
  ownerPrimaryContactNo: {
    required: true,
    message: "Primary contact number cannot be empty.",
    pattern: /^\d{10}$/,
    patternMessage: "Enter a valid 10-digit number.",
  },
  ownerSecondaryContactNo: {
    required: false,
    pattern: /^\d{10}$/,
    patternMessage: "Enter a valid 10-digit number.",
  },
  emailAddress: {
    required: true,
    message: "Please enter your email.",
    pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    patternMessage: "Please enter a valid email address.",
  },
};

// Organization Detail Validations
const organizationDetailValidations = {
  GSTIN: {
    required: true,
    message: "Please enter a valid 15-digit GSTIN.",
  },
  vendorBusinessName: {
    required: true,
    message: "Organization name is required.",
  },
  address: {
    required: true,
    message: "Please enter organization address.",
  },
  state: {
    required: true,
    message: "State is required.",
  },
  city: {
    required: true,
    message: "City is required.",
  },
  pinCode: {
    required: true,
    message: "Pincode is required.",
  },
  yearsInBusiness: {
    required: true,
    message: "Years in business is required.",
    pattern: /^[0-9]+$/,
    patternMessage: "Enter a valid number of years.",
  },
};

const operationalDetailValidations = {
  typeOfBusiness: {
    required: true,
    message: "Please select the type of business.",
  },
  avgTurnoverLast3Years: {
    required: true,
    message: "Please enter average turnover.",
  },
  registeredInESIPF: {
    required: true,
    message: "Please select are you registered in ESIC/PF or not.",
  },
  productionArea: {
    required: true,
    message: "Please enter the production area.",
  },
  numberOfEmployees: {
    required: true,
    message: "Please enter number of employees.",
  },
  numberOfSkilledManpower: {
    required: true,
    message: "Please enter number of skilled manpower.",
  },
  numberOfUnskilledManpower: {
    required: true,
    message: "Please enter number of unskilled manpower.",
  },
  scalingFactors: {
    required: true,
    message: "Scaling factors is required.",
  },
};

// ✅ Validate only personal details
export const validatePersonalDetails = (formData, dispatch) => {
  return validateFields(formData, personalDetailValidations, dispatch);
};

// ✅ Validate only organization details
export const validateOrganizationDetails = (formData, dispatch) => {
  return validateFields(formData, organizationDetailValidations, dispatch);
};

// ✅ Validate only operational details
export const validateOperationalDetails = (formData, dispatch) => {
  return validateFields(formData, operationalDetailValidations, dispatch);
};

// ✅ Full form validation (both)
export const validateAllFields = (formData, dispatch) => {
  const isPersonalValid = validatePersonalDetails(formData, dispatch);
  const isOrgValid = validateOrganizationDetails(formData, dispatch);
  const isoperationalValid = validateOperationalDetails(formData, dispatch);
  return isPersonalValid && isOrgValid && isoperationalValid;
};
